// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"488f5ec9","453":"7a502126","543":"bd43d3b9","732":"b95c59a6","977":"d7e8a64e"}[chunkId] + ".chunk.js";
};